import React from 'react';

import { ITrainingSet } from '../../types/my-types';
import Dropdown from './Dropdown';
import useTrainingSets from '../hooks/useTrainingSets';

export interface SelectTrainingSetProps {
  dataPoolId: string;
  setTrainingSet: (trainingSet: ITrainingSet | undefined) => void;
  disabled?: boolean;
  currentTrainingSetId?: string;
  style?: any;
  includeCurrentTS?: boolean;
}

export interface ITrainingSetsForDropdown {
  id: string;
  label: string;
}

const SelectTrainingSet: React.FC<SelectTrainingSetProps> = ({
  setTrainingSet,
  currentTrainingSetId,
  disabled,
  style,
  includeCurrentTS,
}) => {
  let trainingSets = useTrainingSets(true, true);

  let items: ITrainingSetsForDropdown[] = [];

  if (!includeCurrentTS) {
    items = trainingSets
      .filter((ts: ITrainingSet) => ts.id !== currentTrainingSetId)
      .map((ts: ITrainingSet) => ({
        id: ts.id,
        label: ts.label,
      }));
  } else {
    items = trainingSets.map((ts: ITrainingSet) => ({
      id: ts.id,
      label: ts.label,
    }));
  }

  const selectTS = (value: string) => {
    const selectedTrainSet = trainingSets.find((t: ITrainingSet) => t.id === value);
    setTrainingSet(selectedTrainSet);
  };

  return (
    <Dropdown
      style={style}
      items={items}
      defaultValue={currentTrainingSetId}
      onChangeCallback={selectTS}
      placeholderTitle="Name of Training Set"
      disabled={disabled}
      cypressId="select-training-set"
    />
  );
};

export default SelectTrainingSet;
